import { motion } from "framer-motion";

const EmpathySection = () => (
  <section className="py-24 lg:py-36 border-t border-white/10" data-testid="empathy-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#00FF8F] mb-6" data-testid="empathy-overline">
          01 / The Executive Condition
        </p>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight text-white font-medium" data-testid="empathy-heading">
          The white noise
          <span className="italic text-[#00FF8F]"> that never stops.</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="mt-12 space-y-8 text-base lg:text-lg leading-relaxed text-[#A6A6AD] font-light"
        data-testid="empathy-body"
      >
        <p>
          You are standing by the window of your office on the thirtieth floor at 1:00 AM.
          Outside, everything is silent, but inside your head, there is a{" "}
          <strong className="font-semibold text-white">white noise that never stops</strong>.
          They call it ambition, but the truth is you feel like a tightrope walker balancing
          on a razor-thin wire with the wind blowing hard.
        </p>
        <p>
          You manage capital, deadlines, and expectations. You thought the price to pay for
          status was a <strong className="font-semibold text-white">constant tension in your neck</strong>,
          shallow breath, and chronic brain fog.
        </p>
        <p>
          Then, the market sold you the illusion of commercial biohacking—ice baths, tracking
          rings, and superficial protocols that{" "}
          <strong className="font-semibold text-white">layer stress upon stress</strong>, burning
          out your mitochondria. You cannot cure the cell if your mind is trapped in constant
          survival mode.
        </p>
      </motion.div>
    </div>
  </section>
);

export default EmpathySection;
